export const FETCH_LOAD_ALL_THERMIT_LOG_REQUEST = 'FETCH_LOAD_ALL_THERMIT_LOG_REQUEST'
export const FETCH_LOAD_ALL_THERMIT_LOG_SUCCESS = 'FETCH_LOAD_ALL_THERMIT_LOG_SUCCESS'
export const FETCH_LOAD_ALL_THERMIT_LOG_FALUIRE = 'FETCH_LOAD_ALL_THERMIT_LOG_FALUIRE'
